import {
  formatLongDate as commonFormatLongDate,
  formatLongMonthDay as commonFormatLongMonthDay,
  formatRelative as commonFormatRelative,
  formatShortDate as commonFormatShortDate,
  formatShortMonthDay as commonFormatShortMonthDay,
  formatTime as commonFormatTime,
} from '@rewardopl/utils/date';

import { locale } from '../i18n/i18n';

type Options = {
  locale?: 'de' | 'en' | 'pl' | 'uk';
};

function getOptionsWithLocale(options: Options): Options {
  const optionsWithLocale = {
    ...options,
  };

  if (locale) {
    optionsWithLocale.locale = locale;
  }

  return optionsWithLocale;
}

export function withLocale<T, U>(
  fn: (value?: T, options?: Options) => U,
): (value?: T, options?: Options) => U {
  return function withLocaleInternal(value?: T, options = {}) {
    const optionsWithLocale = getOptionsWithLocale(options);

    return fn(value, optionsWithLocale);
  };
}

export const formatTime = withLocale(commonFormatTime);
export const formatLongDate = withLocale(commonFormatLongDate);
export const formatShortDate = withLocale(commonFormatShortDate);
export const formatLongMonthDay = withLocale(commonFormatLongMonthDay);
export const formatShortMonthDay = withLocale(commonFormatShortMonthDay);
export const formatRelative = withLocale(commonFormatRelative);
